import { useState } from "react";
import * as yup from "yup";
import { useLeadNotificationEmailsQuery } from "../../../../../../api/queries/useLeadNotificationEmailsQuery";
import { uiNotification } from "../../../../../../services/UINotificationService";
import { catch_ } from "../../../../../../utilities/fp";

var validEmail = (email) => () =>
  yup.string().email().validateSync(email, { strict: true });

export const useEmails = () => {
  const [emails, setEmails] = useState([]);

  const { isLoading } = useLeadNotificationEmailsQuery({
    onError: () => {
      uiNotification.error("Failed to load emails");
    },
    onSuccess: (data) => {
      setEmails(data.emails);
    },
    staleTime: 0,
    cacheTime: 0,
  });

  const handleChange = (list) => {
    var len = list.length;
    var isValid = catch_(validEmail(list[len - 1]), () => false);

    if (len === 0 || isValid) {
      setEmails(list);
    }
  };

  return {
    emails,
    setEmails: handleChange,
    isEmailsLoading: isLoading,
  };
};
